import { render, staticRenderFns } from "./autocomplete-cidade.vue?vue&type=template&id=9723605c&"
import script from "./autocomplete-cidade.vue?vue&type=script&lang=js&"
export * from "./autocomplete-cidade.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete-cidade.vue?vue&type=style&index=0&id=9723605c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports